import { Component, OnInit,EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, ActivationEnd } from "@angular/router";
@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponent implements OnInit{
  
   ngOnInit() {
  }
  
}
